import React, {useCallback} from "react";
import {PrimaryButton, SecondaryButton} from "components/Common";
import {useTranslation} from "react-i18next";
import {ButtonsBox, ModalIcon, ModalText, ModalTitle} from "components/Modals/common";
import {BaseModal} from "components/Modals/BaseModal";
import icon from "assets/images/icons/modalWarningIcon.svg";
import {useDispatch, useSelector} from "react-redux";
import {getIsOpenConfirmPicksModal} from "modules/selectors";
import {closeConfirmPicksModal, saveUserTeamRequest} from "modules/actions";
import {ConnextraType, createConnextraScriptTag} from "modules/utils";

export const ConfirmPicksModal: React.FC = () => {
	const {t} = useTranslation();
	const dispatch = useDispatch();
	const isOpen = useSelector(getIsOpenConfirmPicksModal);

	const closeModal = useCallback(() => {
		dispatch(closeConfirmPicksModal());
	}, [dispatch]);

	const handleSave = useCallback(() => {
		dispatch(closeConfirmPicksModal());
		dispatch(saveUserTeamRequest());
		createConnextraScriptTag(ConnextraType.PICKS_CONFIRM, null);
	}, [dispatch]);

	if (!isOpen) {
		return null;
	}

	return (
		<BaseModal handleClose={closeModal}>
			<ModalIcon className="small" src={icon} alt="Warning" />
			<ModalTitle>{t("modal.confirm_picks.title")}</ModalTitle>
			<ModalText>{t("modal.confirm_picks.desc")}</ModalText>
			<ButtonsBox>
				<SecondaryButton onClick={closeModal}>
					{t("modal.confirm_picks.cancel")}
				</SecondaryButton>
				<PrimaryButton onClick={handleSave}>
					{t("modal.confirm_picks.confirm")}
				</PrimaryButton>
			</ButtonsBox>
		</BaseModal>
	);
};
